// Mock data for Eco-Lak clone

export const IMG = {
  logo: '/images/logo.png',
  hero: '/images/hero-finished.jpg',
  frame: '/images/frame.jpg',
  roof_beams: '/images/roof-beams.jpg',
  roof_underlay: '/images/roof-underlay.jpg',
  tiles: '/images/tiles.jpg',
  finished: '/images/hero-finished.jpg',
  construction: '/images/construction.jpg',
  interior: '/images/interior.jpg',
  sunset: '/images/sunset.jpg',
};

export const NAV_ITEMS = [
  { label: 'Pillanatok', href: '#pillanatok' },
  { label: 'Technológia', href: '#technologia' },
  { label: 'Életérzés', href: '#eleterzes' },
  { label: 'Készházak', href: '#keszhazak' },
  { label: 'Referenciák', href: '#referenciak' },
];

export const TOP_BAR = {
  phone: '+36 20 423 7308',
  email: 'ecolakepitokft@gmail.com',
  location: 'Velencei-tó, Fejér megye',
  hours: 'H-P: 8:00 - 17:00',
};

export const MOMENTS = [
  {
    num: '01',
    tag: 'Szerkezet',
    title: 'Felemeljük a vázat.',
    desc: 'A CNC precizitással gyártott fa szerkezet a helyszínen áll össze – néhány nap alatt készen áll a következő fázisra.',
    region: 'Velencei-tó régió',
    image: '/images/frame.jpg',
  },
  {
    num: '02',
    tag: 'Tetőszerkezet',
    title: 'Pontos szögek, erős kötések.',
    desc: 'A tetőszerkezet gyárilag előregyártott elemekből épül – statikailag pontos, szélálló és időtálló megoldás.',
    region: 'Velencei-tó régió',
    image: '/images/roof-beams.jpg',
  },
  {
    num: '03',
    tag: 'Tetőfedés',
    title: 'Vízzáró aláhéjazás.',
    desc: 'Prémium minőségű TERRAN aláhéjazás és léctávolság – a cserép alá tökéletesen védett, lélegző réteg kerül.',
    region: 'Velencei-tó régió',
    image: '/images/roof-underlay.jpg',
  },
  {
    num: '04',
    tag: 'Cseréptető',
    title: 'Időtálló cserépborítás.',
    desc: 'Magas minőségű cserép, gondos kivitelezésben. A tetőfedés után a homlokzat és a belső munkák következhetnek.',
    region: 'Velencei-tó régió',
    image: '/images/tiles.jpg',
  },
  {
    num: '05',
    tag: 'Kulcsrakész',
    title: 'Tiszta vonalak, kész otthon.',
    desc: 'A homlokzat kész, a tető tökéletes, az otthon pedig várja gazdáját – a Velencei-tó környékén, álomszerű környezetben.',
    region: 'Velencei-tó régió',
    image: '/images/hero-finished.jpg',
  },
];

export const MARQUEE_BADGES = [
  'A++ Energiaosztály',
  'CNC Precizitás',
  'Velencei-tó Régió',
  'Passzívház Szabvány',
  'Egyedi Tervezés',
  'Helyszíni Összeszerelés',
];

export const WHY_FEATURES = [
  { icon: 'MapPin', title: 'Vízparti lokáció', desc: 'Válogatott telkek a Velencei-tó 500 méteres körzetében. Stég, vízpart, természet – karnyújtásnyira.' },
  { icon: 'Leaf', title: 'A++ energiaosztály', desc: 'Passzívház szabvány. Akár 80%-kal alacsonyabb rezsi.' },
  { icon: 'Ruler', title: 'CNC precizitás', desc: 'Milliméter pontos vágás, gyári minőségellenőrzés.' },
  { icon: 'PencilRuler', title: 'Egyedi tervezés', desc: 'Saját építészek, a tó adottságaihoz.' },
];

export const TECH_STEPS = [
  { num: '01', title: 'Gyári előregyártás', desc: 'CNC géppel vágott elemek, kontrollált körülmények között. Minőségellenőrzés minden darabon.' },
  { num: '02', title: 'Egyben szállítás', desc: 'Az összes elem egyetlen konvojjal érkezik a Velencei-tó melletti helyszínre.' },
  { num: '03', title: 'Összeszerelés', desc: 'Szélálló, vízálló szerkezet, azonnal terhelhető. Minőségi munka, profi csapattal.' },
];

export const TECH_STATS = [
  { value: 'A++', label: 'Energiaosztály' },
  { value: '160mm', label: 'Kőzetgyapot' },
  { value: '< 0.15', label: 'U-érték (W/m²K)' },
  { value: 'CNC', label: 'Precizitás' },
];

export const LIFE_STATS = [
  { value: '180°', label: 'Tó-panoráma' },
  { value: '30p', label: 'Budapest' },
  { value: '12 ha', label: 'Zöldövezet' },
];

export const LIFE_BULLETS = [
  'Reggeli kávé a Velencei-tó panorámájával',
  'Természetes fénnyel átjárt, tágas terek',
  'Saját stég és vízparti kert lehetőség',
  'Csend, nyugalom, madárcsicsergés',
  '30 perc Budapest – vidéki élet városi közelségben',
];

export const PACKAGES = [
  {
    id: 'alap',
    badge: '01',
    label: 'Alap',
    popular: false,
    title: 'Alap csomag',
    image: '/images/hero-finished.jpg',
    desc: 'A klasszikus könnyűszerkezetes készház: letisztult vonalak, cseréptető, időtálló karakter.',
    specs: [
      { value: '80–120 m²', label: 'terület' },
      { value: '3–4', label: 'szoba' },
      { value: '1–2', label: 'szint' },
    ],
    items: [
      'Könnyűszerkezetes vázszerkezet, OSB burkolattal',
      'Cseréptető, tartósan stabil',
      'Kőzetgyapot hőszigetelés (160 mm)',
      'A++ energiaosztály',
      'Kulcsrakész átadás',
    ],
  },
  {
    id: 'csaladi',
    badge: '02',
    label: 'Családi',
    popular: true,
    title: 'Családi csomag',
    image: '/images/tiles.jpg',
    desc: 'Tágasabb otthon a növekvő családoknak. Modern formák, nagy üvegfelületek, panorámás nappali.',
    specs: [
      { value: '120–180 m²', label: 'terület' },
      { value: '4–5', label: 'szoba' },
      { value: '1–2', label: 'szint' },
    ],
    items: [
      'Erősített könnyűszerkezetes vázszerkezet',
      'Lapostető vagy modern nyeregtető',
      'Panoráma üvegfelületek',
      'Padlófűtés, hőszivattyú előkészítés',
      'Egyedi belsőépítészeti konzultáció',
    ],
  },
  {
    id: 'premium',
    badge: '03',
    label: 'Prémium',
    popular: false,
    title: 'Prémium csomag',
    image: '/images/roof-beams.jpg',
    desc: 'Egyedi tervezésű prémium otthon, exkluzív anyagokkal, intelligens otthon rendszerekkel.',
    specs: [
      { value: '180+ m²', label: 'terület' },
      { value: '5+', label: 'szoba' },
      { value: '2', label: 'szint' },
    ],
    items: [
      'Prémium könnyűszerkezetes szerkezet, megerősített elemek',
      'Természetes fa- és kőhomlokzat',
      'Smart home rendszer integrálva',
      'Hőszivattyú + napelem csomag',
      'Saját építész, design konzultáció',
    ],
  },
];

export const REFERENCES_STATS = [
  { value: 145, suffix: '+', label: 'Felépített Otthon' },
  { value: 14, suffix: ' Év', label: 'Tapasztalat' },
  { value: 96, suffix: '%', label: 'Elégedettség' },
];

export const TESTIMONIALS = [
  {
    initial: 'K',
    name: 'Kovács Anna és Péter',
    place: 'Gárdony, 2024',
    text: 'A Velencei-tó partján mindig is álmodtunk egy otthonról. Az Eco-Lak csapata 4 hónap alatt megépítette. Minden reggel a vízre ébredünk – ez a legjobb döntés volt az életünkben.',
  },
  {
    initial: 'S',
    name: 'Szabó Márton',
    place: 'Agárd, 2023',
    text: 'Profi, gyors, megbízható. A szomszédok nem hitték el, milyen gyorsan állt a ház. A minőség pedig magáért beszél – télen is kellemes meleg, nyáron hűvös.',
  },
];

export const CONFIG_STEPS = [
  {
    num: '01',
    title: 'Projekt',
    subtitle: 'Milyen otthont álmodik meg?',
    questions: [
      {
        q: 'Milyen projektet tervez?',
        options: [
          { v: 'allando', label: 'Állandó otthon', sub: 'Egész éves lakhatás' },
          { v: 'nyaralo', label: 'Nyaraló', sub: 'Hétvégi pihenő a tónál' },
          { v: 'befektetes', label: 'Befektetés', sub: 'Kiadásra, Airbnb' },
          { v: 'egyeb', label: 'Egyéb', sub: 'Iroda, vendégház, stb.' },
        ],
      },
      {
        q: 'Rendelkezik már telekkel?',
        options: [
          { v: 'igen', label: 'Igen, van' },
          { v: 'nem', label: 'Nem, keresek' },
          { v: 'segit', label: 'Segítséget kérek' },
        ],
      },
    ],
  },
  {
    num: '02',
    title: 'Méret',
    subtitle: 'Mekkora otthonra vágyik?',
    questions: [
      {
        q: 'Hány négyzetmétert tervez?',
        options: [
          { v: '60-80', label: '60–80 m²', sub: 'Kompakt, hatékony' },
          { v: '80-120', label: '80–120 m²', sub: 'Klasszikus családi méret' },
          { v: '120-180', label: '120–180 m²', sub: 'Tágas családi otthon' },
          { v: '180+', label: '180 m² felett', sub: 'Prémium kategória' },
        ],
      },
    ],
  },
  {
    num: '03',
    title: 'Stílus',
    subtitle: 'Milyen formavilág áll közel Önhöz?',
    questions: [
      {
        q: 'Válassza ki a stílust',
        options: [
          { v: 'modern', label: 'Modern', sub: 'Letisztult, minimal' },
          { v: 'klasszikus', label: 'Klasszikus', sub: 'Hagyományos cseréptető' },
          { v: 'mediterran', label: 'Mediterrán', sub: 'Vízparti hangulat' },
        ],
      },
    ],
  },
  {
    num: '04',
    title: 'Időzítés',
    subtitle: 'Mikorra szeretné a kulcsokat?',
    questions: [
      {
        q: 'Tervezett kezdés',
        options: [
          { v: 'azonnal', label: 'Azonnal', sub: '1–2 hónapon belül' },
          { v: 'fel-ev', label: 'Fél éven belül' },
          { v: 'ev', label: 'Egy éven belül' },
          { v: 'kesobb', label: 'Később', sub: 'Még tájékozódom' },
        ],
      },
    ],
  },
  {
    num: '05',
    title: 'Költségvetés',
    subtitle: 'Milyen keretet szán a projektre?',
    questions: [
      {
        q: 'Tervezett költségvetés',
        options: [
          { v: '30-50', label: '30–50 M Ft' },
          { v: '50-80', label: '50–80 M Ft' },
          { v: '80-120', label: '80–120 M Ft' },
          { v: '120+', label: '120 M Ft felett' },
        ],
      },
    ],
  },
  {
    num: '06',
    title: 'Kapcsolat',
    subtitle: 'Hogyan érjük el?',
    questions: [
      {
        q: 'Adatok',
        type: 'contact',
      },
    ],
  },
];
